import { API } from "apis";
import { getViaAuth, responseValidator } from "apis/api";
import { PaginationList } from "core/domain";
import { UtopiaVoucher } from "core/domain/utopia-vouchers/utopia-vouchers";
import { Dispatch, SetStateAction } from "react";

export const getAllUtopiaVouchers = (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: any,
    page: number,
    pageSize: number,
    query: string,
) => {
    setLoading(true);
    getViaAuth<PaginationList<UtopiaVoucher>>(
        `${API.voucher.utopiaVouchers}/${page}/${pageSize}${query}`,
    ).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
        }
    });
};